import { getApv } from '../../apis';
import {
  cardNumberForm,
  closeBottomSheet,
  decodeJWT,
  deserialize,
  getIframe,
  serialize,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  showBottomSheet,
  sortMethod,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { amtFormatter } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const PayMethod = {
  selectedItem: {},
  info: {},
  charge: {},
  chargeFlag: true,
  cardFlag: true,
  accountFlag: true,
  account: [],
  card: [],
  render: async () => {
    PayMethod.info = decodeJWT();

    return `
        <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
        <div class="c_title1">결제수단 관리</div>


        <div id="pay_method_list" class="m_b_30"></div>
        <div class="m_b_80" id="pay_method"><a href="javascript:void(0)" class="c_label4_3">+  결제수단 추가</a></div>

        <div class="m_b_80" id="card_modal_item"></div>
        <div class="m_b_80" id="account_modal_item"></div>

        <div class="modal c_btm1" id="pay_method_content">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">결제수단</h5>
                <button type="button" id="close_modal" class="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div>
                <div class="modal-body" id="pay_method_modal_body">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal c_btm1" id="charge_method_item_content">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">충전머니</h5>
                <button type="button" id="close_modal" class="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div>
                <div class="modal-body" id="money_modal_body">
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="modal c_btm1" id="card_modal_item_content">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">카드</h5>
              <button type="button" id="close_modal" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div>
              <div class="modal-body" id="card_modal_body">
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="modal c_btm1" id="account_modal_item_content">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">계좌</h5>
            <button type="button" id="close_modal" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div>
            <div class="modal-body" id="account_modal_body">
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
  },
  afterRender: async () => {
    setAlertModal();
    setAlertModal(false, 'back_alert');

    // functions
    const setSelectItem = async (value) => {
      PayMethod.selectedItem = value;
    };
    const setModalItemEvent = async (list, id) => {
      for (const index in list) {
        setAddEventListener(`${id}_${index}`, async () => {
          await list[index].fn();
        });
      }
    };

    const setFirstCard = () => {
      closeBottomSheet('card_modal_item');

      const methods = `methods=CARD`;
      const entyno = `entyno=${PayMethod.selectedItem.cardEntyno}`;

      getApv(`common/mainUseUpdate?${methods}&${entyno}`)
        .then((res) => {
          showAlertModal('주 카드 설정', '주 카드로 설정되었습니다.', () =>
            refresh()
          );
        })
        .catch((e) => {
          showAlertModal('오류', e.resultMessage, null);
          console.error(e.resultMessage);
        });
    };
    const setFirstAccount = () => {
      closeBottomSheet('account_modal_item');

      const methods = `methods=ACCOUNT`;
      const entyno = `entyno=${PayMethod.selectedItem.accEntyno}`;

      getApv(`common/mainUseUpdate?${methods}&${entyno}`)
        .then((_) => {
          showAlertModal('주 계좌 설정', '주 계좌로 설정되었습니다.', () =>
            refresh()
          );
        })
        .catch((e) => {
          showAlertModal('오류', e.resultMessage, null);
          console.error(e.resultMessage);
        });
    };
    const delCard = async () => {
      closeBottomSheet('card_modal_item');

      const entyno = PayMethod.selectedItem.cardEntyno;
      const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
      const merchantId =
        brandInfo.bndBizDivCode == '1'
          ? process.env.SEEROO_MERCHANT_ID_OFFLINE
          : process.env.SEEROO_MERCHANT_ID_ONLINE;

      showAlertModal('카드 삭제', '카드를 삭제하시겠습니까?', async () => {
        getApv(`card/delMethods?cardEntyno=${entyno}&merchantId=${merchantId}`)
          .then((_) => {
            showAlertModal(
              '카드 삭제',
              '카드가 삭제 되었습니다.',
              () => refresh(),
              'back_alert'
            );
          })
          .catch((e) => {
            showAlertModal('오류', e.resultMessage, null, 'back_alert');
            console.error(e.resultMessage);
          });
      });
    };
    const delAccount = async () => {
      closeBottomSheet('account_modal_item');
      const entyno = `accEntyno=${PayMethod.selectedItem.accEntyno}`;
      showAlertModal('계좌 삭제', '계좌를 삭제하시겠습니까?', () => {
        getApv(`account/delMethods?${entyno}`)
          .then((_) => {
            showAlertModal(
              '카드 삭제',
              '계좌가 삭제 되었습니다.',
              () => refresh(),
              'back_alert'
            );
          })
          .catch((e) => {
            showAlertModal('오류', e.resultMessage, null, 'back_alert');
            console.error(e.resultMessage);
          });
      });
    };

    // 결제수단
    const payMethodItemList = [];

    const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
    if (brandInfo.service.charge || brandInfo.service.account) {
      payMethodItemList.push({
        name: '계좌 등록',
        fn: () => {
          closeBottomSheet('pay_method');
          pushRouter(null, null, routes.accountRegi.hashPath);
        },
      });
    }
    if (brandInfo.service.card) {
      payMethodItemList.push({
        name: '카드 등록',
        fn: () => {
          closeBottomSheet('pay_method');
          pushRouter(null, null, routes.cardRegi.hashPath, () => {
            setDisableBackControl();
          });
        },
      });
    }

    // 충전머니
    const chargeItemList = [
      // {
      //   name: '충전하기',
      //   fn: () => {
      //     //히스토리에 데이터 넣어줘야함
      //     pushRouter(null, null, routes.chargDeposit.hashPath)
      //   },
      // },
      {
        name: '자동충전 설정',
        fn: () => pushRouter(null, null, routes.chargDepositAuto.hashPath),
      },
    ];
    // 카드
    const cardItemList = [
      {
        name: '주카드로 설정',
        fn: setFirstCard,
      },
      {
        name: '카드 삭제',
        fn: delCard,
      },
    ];
    // 계좌
    const accountItemList = [
      {
        name: '주계좌로 설정',
        fn: setFirstAccount,
      },
      {
        name: '계좌 삭제',
        fn: delAccount,
      },
    ];

    // view DrawFunctions
    const drwModalItem = async (list, targetId, id) => {
      const modalItem = list
        .map(
          (itme, index) =>
            `<div></div>
               <div class="item c_label6_1" id="${id}_${index}">
                 ${itme.name}
               </div>
             </div>`
        )
        .reduce((a, b) => a + b);

      setIframeInnerHtml(targetId, modalItem);
    };
    const drawChargeMethodList = async () => {
      let methodListHtml = '';
      try {
        PayMethod.charge = await getApv('charging/moneyBalance'); // 브랜드에서 사용 , 계좌
        const charge = PayMethod.charge;

        methodListHtml += `<div id="charge_method_item" class="c_pay_method m_b_20 skin1_btn" value="${serialize(
          { trDiv: '3001', charge }
        )}">
                        <div class="c_label7_2 m_b_10">충전머니</div>
                        <div class="c_box">
                          <div class="c_label7_1">현재잔액</div>
                          <div class="c_label7_1">${amtFormatter(
                            charge.chrgBal
                          )} 원</div>
                        </div>
                      </div>`;
      } catch (err) {
        throw new err();
      }
      return methodListHtml;
    };
    const drawCardMethodList = async () => {
      let methodListHtml = '';

      const card = PayMethod.card;

      for (const index in card) {
        methodListHtml += `<div id="card_method_item_${index}" class="c_pay_method m_b_20" style="background: ${
          card[index].ref1 || '#000555'
        }" value="${serialize({ trDiv: '1001', ...card[index] })}">
                    <div class="c_box">
                        <div class="c_label7_2 m_b_10">${
                          card[index].cardCoName
                        }</div>
                        <div class="c_label7_2 m_b_10" style="font-size: 12px ">${
                          card[index].cardName
                        }</div>
                    </div>
                    <div class="c_box">
                        <div class="c_label7_1">${
                          card[index].mainUseYn == 'Y' ? '주 카드' : ''
                        }</div>
                        <div class="c_label7_1"> ${cardNumberForm(
                          card[index].cardBin
                        )}</div>
                    </div>
                </div>`;
      }
      return methodListHtml;
    };
    const drawAccountMethodList = async () => {
      let methodListHtml = '';
      const account = PayMethod.account;
      for (const index in account) {
        methodListHtml += `<div id="account_method_item_${index}" class="c_pay_method m_b_20" style="background: ${
          account[index].ref2 || '#000555'
        }" value="${serialize({ trDiv: '1001', ...account[index] })}">
                    <div class="c_box">
                        <div class="c_label7_2 m_b_10">${
                          account[index].bnkName
                        }</div>
                    </div>
                    <div class="c_box">
                        <div class="c_label7_1">${
                          account[index].mainUseYn == 'Y' ? '주 계좌' : ''
                        }</div>
                        <div class="c_label7_1"> ${account[index].accno}</div>
                    </div>
                </div>`;
      }
      return methodListHtml;
    };
    const drawMethodList = async () => {
      let methodListHtml = '';
      const branInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
      PayMethod.chargeFlag = branInfo.service.charge;
      PayMethod.cardFlag = branInfo.service.card;
      PayMethod.accountFlag = branInfo.service.account;

      //브랜드 가 각 해당 서비스를 사용하면 그리기
      //충전머니의 경우 브랜드에서 서비스를 사용하면 그리기
      methodListHtml += PayMethod.chargeFlag
        ? await drawChargeMethodList()
        : '';

      //카드의 경우 브랜드에서 서비스를 사용하면 그리기
      methodListHtml += PayMethod.cardFlag ? await drawCardMethodList() : '';

      //계좌의 경우 브랜드에서 서비스를 사용하면 그리기
      methodListHtml += PayMethod.accountFlag
        ? await drawAccountMethodList()
        : '';

      setIframeInnerHtml('pay_method_list', methodListHtml);
    };

    const drawModal = async () => {
      await drwModalItem(
        payMethodItemList,
        'pay_method_modal_body',
        'pay_method'
      );
      await drwModalItem(chargeItemList, 'money_modal_body', 'charge_method');
      await drwModalItem(cardItemList, 'card_modal_body', 'card_method');
      await drwModalItem(
        accountItemList,
        'account_modal_body',
        'account_method'
      );

      setBottomSheet('pay_method');
      setBottomSheet('charge_method_item');
      setBottomSheet('card_modal_item');
      setBottomSheet('account_modal_item');

      await setModalItemEvent(payMethodItemList, 'pay_method');
      await setModalItemEvent(chargeItemList, 'charge_method');
      await setModalItemEvent(cardItemList, 'card_method');
      await setModalItemEvent(accountItemList, 'account_method');
    };

    const setEvent = async () => {
      if (PayMethod.chargeFlag) {
        setAddEventListener(`charge_method_item`, async () => {
          const serializeValue = getIframe()
            .getElementById('charge_method_item')
            .getAttribute('value');
          const valueObj = deserialize(serializeValue);
          await setSelectItem(valueObj);
        });
      }
      if (PayMethod.cardFlag) {
        for (const index in PayMethod.card) {
          setAddEventListener(`card_method_item_${index}`, async () => {
            const serializeValue = getIframe()
              .getElementById(`card_method_item_${index}`)
              .getAttribute('value');
            const valueObj = deserialize(serializeValue);
            await setSelectItem(valueObj);
            getIframe().getElementById('card_modal_item').click();
          });
        }
      }
      if (PayMethod.accountFlag) {
        for (const index in PayMethod.account) {
          setAddEventListener(`account_method_item_${index}`, async () => {
            const serializeValue = getIframe()
              .getElementById(`account_method_item_${index}`)
              .getAttribute('value');
            const valueObj = deserialize(serializeValue);
            await setSelectItem(valueObj);
            getIframe().getElementById('account_modal_item').click();
          });
        }
      }
    };

    const viewLoad = async () => {
      try {
        const methodList = await getApv('common/methodList');
        PayMethod.account = methodList.accountList.sort(sortMethod);
        PayMethod.card = methodList.cardList.sort(sortMethod);

        // 등록된 결제수단(카드, 계좌) 하나도 없으면 '결제수단 추가 BottomSheet' 보여줌
        if (PayMethod.card.length === 0 && PayMethod.account.length === 0) {
          showBottomSheet('pay_method');
        }

        await drawMethodList();

        await setEvent();
      } catch (e) {
        PayMethod.charge = {};
        PayMethod.account = [];
        PayMethod.card = [];
        showAlertModal('오류', e.resultMessage || e);
        console.error(e.resultMessage);
      }
    };

    const refresh = async () => {
      await viewLoad();
    };

    //DrawMethodList
    await viewLoad();

    await drawModal();

    setAddEventListener('connect_pay_back_button', () => history.back());
  },
};
export default PayMethod;
